var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46 16.414c4.112 0 6.888-3.595 6.888-6.951h1.572c0 4.123-3.405 8.537-8.46 8.537C3.405 18 0 13.586 0 9.463 0 5.339 3.405.925 8.46.925c2.75 0 4.976 1.375 6.365 2.908L14.772.026 16.344 0l.105 6.766-6.706-.105.027-1.586 4.112.053c-1.1-1.322-3.012-2.643-5.422-2.643-3.326 0-6.888 2.801-6.888 6.951 0 3.383 2.776 6.978 6.888 6.978Z",
    fill: "#424242"
  })));
};

export default SvgRefresh;